"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const tabs = [
    {
        id: "strategy",
        label: "Strategy",
        title: "Strategic Immersive Consulting",
        description: "We define the roadmap for your spatial computing journey. Our experts analyze use cases, tech feasibility, and ROI to ensure your immersive initiatives align with business goals.",
        image: "/images/ar-vr/limitless-strategy-real.png",
        date: "01",
        author: "Consulting"
    },
    {
        id: "development",
        label: "Development",
        title: "High-Fidelity Engineering",
        description: "Our diverse team of engineers builds robust, scalable AR/VR applications using top-tier engines. We focus on performance optimization to deliver butter-smooth experiences on any hardware.",
        image: "/images/ar-vr/limitless-development-real.png",
        date: "02",
        author: "Engineering"
    },
    {
        id: "deployment",
        label: "Deployment",
        title: "Enterprise Scale Integration",
        description: "We ensure seamless integration of immersive solutions into your existing IT infrastructure. From MDM setup to security protocols, we handle full-scale deployment.",
        image: "/images/ar-vr/limitless-deployment.png",
        date: "03",
        author: "Operations"
    }
];

export default function LimitlessPossibilitiesSection() {
    const [activeTab, setActiveTab] = useState(tabs[0]);

    return (
        <section className="bg-black text-white pt-16 pb-8 lg:pt-32 lg:pb-16 px-6 overflow-hidden">
            <div className="max-w-[1400px] mx-auto">

                {/* Main Heading */}
                <h2 className="text-[3rem] tracking-tight mb-12 lg:mb-24 max-w-4xl leading-tight">
                    LIMITLESS POSSIBILITIES <br />
                    WITH IMMERSIVE TECH
                </h2>

                <div className="grid grid-cols-1 lg:grid-cols-[200px_1fr_400px] gap-8 lg:gap-24 items-start">

                    {/* Navigation Menu */}
                    <div className="flex flex-row lg:flex-col gap-4 lg:gap-8 pt-2 lg:pt-8 overflow-x-auto whitespace-nowrap no-scrollbar pb-4 lg:pb-0">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab)}
                                className={`text-left text-lg md:text-xl font-medium transition-colors duration-300 ${activeTab.id === tab.id
                                    ? "text-white"
                                    : "text-gray-600 hover:text-gray-400"
                                    }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Center Image Area */}
                    <div className="relative aspect-[4/3] md:aspect-[16/9] lg:aspect-auto lg:h-[500px] rounded-2xl overflow-hidden bg-white/5">
                        <AnimatePresence mode="wait">
                            <motion.img
                                key={activeTab.id}
                                src={activeTab.image}
                                alt={activeTab.title}
                                initial={{ opacity: 0, scale: 1.05 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                className="w-full h-full object-cover"
                            />
                        </AnimatePresence>
                    </div>

                    {/* Content Area */}
                    <div className="flex flex-col justify-between h-full pt-4">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={activeTab.id}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.3, delay: 0.1 }}
                                className="flex flex-col h-full"
                            >
                                <h3 className="text-3xl md:text-4xl leading-tight font-light mb-6">
                                    {activeTab.title}
                                </h3>

                                <p className="text-gray-400 text-[1.125rem] leading-relaxed mb-8">
                                    {activeTab.description}
                                </p>


                            </motion.div>
                        </AnimatePresence>
                    </div>

                </div>

            </div>
        </section>
    );
}
